<template>
<div class="postulant-menu-two-base">
    <ul class="postulant-menu-two">
    <li v-on:click="goToSteps(0)">sobre la feria</li>
    <li v-on:click="goToSteps(0)">instrucciones</li>
    <li v-on:click="goToSteps(1)"  v-on:mouseleave="hideMenu()">
      <div class="menu-title" v-on:mouseover="displayMenu(1)">
        <span>1</span>
        <p> datos generales</p>
      </div>
      <div class="menu-opt" v-show="generaldata" v-on:mouseleave="hideMenu()">
        <p>información general</p>
        <p>datos de facturación</p>
        <p>director(es)</p>
        <p>contacto(s) para artbo feria</p>
        <p>términos y dirección</p>      
      </div>
    </li>
    <li v-on:click="goToSteps(2)"  v-on:mouseleave="hideMenu()">
      <div class="menu-title"  v-on:mouseover="displayMenu(2)">
        <span>2</span>
        <p> la galería</p>
      </div>
      <div class="menu-opt" v-show="gallerydata" v-on:mouseleave="hideMenu()">
        <p>programación de la galería</p>
        <p>artistas representados</p>
        <p>ferias 2017 | 2018 | 2019</p>
      </div>
    </li>
    <li v-on:click="goToSteps(3)"  v-on:mouseleave="hideMenu()">
      <div class="menu-title"  v-on:mouseover="displayMenu(3)">
        <span>3</span>
        <p> selección de stand</p>        
      </div>
      <div class="menu-opt" v-show="standselection" v-on:mouseleave="hideMenu()">
        <p>stand plus</p>
        <p>stand 63 mts</p>
        <p>stand 45 mts</p>
        <p>stand 31,5 mts</p>
        <p>stand 21 mts</p> 
      </div>
    </li>
    <li>
      <div class="menu-title"  v-on:mouseover="displayMenu(4)">
        <span>4</span>
        <p> propuesta para ARTBO</p>
      </div>
      <div class="menu-opt" v-show="proposalArtbo" v-on:mouseleave="hideMenu()">
        <p>artistas y reseña</p>
      </div>      
    </li>
    <li>
      <div class="menu-title"  v-on:mouseover="displayMenu(5)">
        <span>5</span>
        <p> documentación</p>
      </div>
      <div class="menu-opt" v-show="documents" v-on:mouseleave="hideMenu()">
        <p>certificado de existencia</p>
        <p>RUT o identificación fiscal</p>
        <p>documento de identidad</p>
      </div>
    </li>
    <li>
      <div class="menu-title"  v-on:mouseover="displayMenu(6)">
        <span>6</span>
        <p> pagos</p>
      </div>
      <div class="menu-opt" v-show="payment" v-on:mouseleave="hideMenu()">
        <p>instrucciones</p>
        <p>registro de pago</p>
      </div>
    </li>
    <li>
      <div class="menu-title"  v-on:mouseover="displayMenu(7)">
        <span>7</span>
        <p> reglamento y participación</p>
      </div>
      <div class="menu-opt" v-show="rulesArtbo" v-on:mouseleave="hideMenu()">
        <p>reglamento de participacion en artbo feria</p>
        <p>reglamento de pagos</p>
        <p>reglamento de aduanas</p>
      </div>
    </li>      
    <li>
      <div class="menu-title"  v-on:mouseover="displayMenu(8)">
        <span>8</span>
        <p> finalización</p>
      </div>
    </li>
  </ul>
</div>  
</template>
<script>
export default{
  data(){
    return{
      menuOpt: false,
      generaldata: false,
      gallerydata: false,
      standselection: false,
      proposalArtbo : false,
      documents: false,
      payment: false,
      rulesArtbo: false
    };
  },
  methods:{
    displayMenu(arg){
      this.menuOpt = true
      this.generaldata = false
      this.gallerydata = false
      this.standselection = false
      this.proposalArtbo  = false
      this.documents = false
      this.payment = false
      this.rulesArtbo = false
      if (arg == 1) {
        this.generaldata = true;
      }      
      if (arg == 2) {
        this.gallerydata = true
      }
      if (arg == 3) {
        this.standselection = true
      }
      if (arg == 4) {
        this.proposalArtbo = true
      }
      if (arg == 5) {
        this.documents = true
      }
      if (arg == 6) {
        this.payment = true
      }
      if (arg == 7) {
        this.rulesArtbo = true
      }
    },
    hideMenu(){
      this.menuOpt = false
      this.generaldata = false
      this.gallerydata = false
      this.standselection = false
      this.proposalArtbo  = false
      this.documents = false
      this.payment = false
      this.rulesArtbo = false
    },
    goToSteps(arg){
      if(arg == 0){
        this.$router.push({ name: 'information' })
      }
      if(arg == 1){
        this.$router.push({ name: 'generalData' })
      }
      if(arg == 2){
        this.$router.push({ name: 'gallery' })
      }
      if(arg == 3){
        this.$router.push({ name: 'standSelection' })
      }
    }
  }
}
</script>
<style type="text/css">
.postulant-menu-two-base{
  width: 100vw;
  margin-bottom: 0px;
}
.opt-content > p:hover{
  color: #4cabc9;
}
.postulant-menu-two{
  width: 100%;
  list-style: none;
  display: inline-flex;
  word-wrap: break-word;
  white-space: normal;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  padding: 10px 0px;
  margin-bottom: 0px;
  height: 7vh; 
}
.menu-title{
    display: flex;
    flex-direction: row;
    text-align-last:justify;
}
.menu-title > span{
    border: 1px solid black;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.3vw;
    margin-bottom: 0.5vh;
}
.menu-opt{
    width: 20vw;
    color: white;
    background-color: #010101;
    position: absolute;
    top: 5vh;
    padding-top: 10%;
    padding-left: 10%;
    padding-right: 10%;
    z-index: 1000;
}
.postulant-menu-two > li{
  width: auto;
  display: flex;
  padding: 0px 10px;
  text-transform: uppercase;
  font-size: 0.7em;
  font-weight: bold;
  flex-direction: column;
  position: relative;
}

.postulant-menu-two > li:hover, .menu-opt > p:hover{
  color: #4cabc9;
  border-color: #4cabc9;
  cursor: pointer;
}
</style>